import { useEffect, useState } from "react";

import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";
import { DropDownMultiCheck } from "../../AdvanceSearch/DropDownMultiCheck";

export default function BusinessArea({ searchObject, onChange, t }) {
  const [businessAreaList, setBusinessAreaList] = useState([]);

  useEffect(() => {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreaList(data);
    });
  }, []);
  function onchangeCandidateBusinessAreas(selecteds) {
    onChange({ target: { name: "businessAreas", value: selecteds } });
  }

  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Business Area")}</legend>{" "}
        <DropDownMultiCheck
          dataList={businessAreaList}
          selecteds={searchObject.businessAreas || []}
          setSelecteds={onchangeCandidateBusinessAreas}
          label={t("Business Area...")}
          hideSelected={true}
        />
      </div>
    </>
  );
}
